import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

// The one worker shape ~40 sagas share: call the API, toast + FAILED action
// on error, dispatch the success action otherwise. Anything that needs more
// (multi-put, refetch, sockets) stays a hand-written generator.
//
// trigger:    action type to watch (takeLatest)
// apiCall:    api call function
// args:       action => [call args] (default: no args)
// onSuccess:  (response, action) => success action to put
// failedType: action type to put on error
// onFailed:   optional (response, action) => failure action, instead of failedType
export const fetchSaga = ({ trigger, apiCall, args = () => [], onSuccess, failedType, onFailed }) =>
  function* watcher() {
    yield takeLatest(trigger, function* worker(action) {
      const response = yield call(apiCall, ...args(action));
      if (response.hasError) {
        toast.error(response.error.message);
        return yield put(onFailed ? onFailed(response, action) : { type: failedType });
      }
      yield put(onSuccess(response, action));
    });
  };
